import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'
import { ReactComponent as SvgLogoUnstyled1 } from '../../assets/icons/svg/first-step-icon.svg'
import { ReactComponent as SvgLogoUnstyled2 } from '../../assets/icons/svg/second-step-icon.svg'
import { ReactComponent as SvgLogoUnstyled3 } from '../../assets/icons/svg/third-step-icon.svg'

type SvgProps={
  stepfill: string
}

const media = generateMedia({
  xs: '350px',
  sm: '550px',
  md: '768px',
  lg: '1200px',
})
export const SvgStepIcon1 = styled(SvgLogoUnstyled1)<SvgProps>`
 ${({ stepfill }) => css`
  rect{
    fill:${stepfill};
  }
  --baseHeight: 85px;
  --baseWidth: 85px;

  height: var(--baseHeight);
  width: var(--baseWidth);
  ${media.between('sm', 'md')`
  height: calc(var(--baseHeight) / 1.5625);
  width: calc(var(--baseWidth) / 1.5625);
  `
}
  ${media.between('xs', 'sm')`
  height: calc(var(--baseHeight) / 2.181);
  width: calc(var(--baseWidth) / 2.181);
  `
}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight) / 3.428);
  width: calc(var(--baseWidth) /3.428);
  `}
  
  
`
}
`
export const SvgStepIcon2 = styled(SvgLogoUnstyled2)<SvgProps>`
  ${({ stepfill }) => css`
  rect{
    fill:${stepfill};
  }
  --baseHeight: 85px;
  --baseWidth: 85px;

  height: var(--baseHeight);
  width: var(--baseWidth);
  ${media.lessThan('md')`
  height: calc(var(--baseHeight)/1.5625);
  width: calc(var(--baseWidth)/1.5625);
  `}
  ${media.lessThan('sm')`
  height: calc(var(--baseHeight)/2.181);
  width: calc(var(--baseWidth)/2.181);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/3.428);
  width: calc(var(--baseWidth)/3.428);
  `}
  
`
}
`
export const SvgStepIcon3 = styled(SvgLogoUnstyled3)<SvgProps>`
   ${({ stepfill }) => css`
  rect{
    fill:${stepfill};
  }
  --baseHeight: 85px;
  --baseWidth: 85px;

  height: var(--baseHeight);
  width: var(--baseWidth);
  ${media.lessThan('md')`
  height: calc(var(--baseHeight)/1.5625);
  width: calc(var(--baseWidth)/1.5625);
  `}
  ${media.lessThan('sm')`
  height: calc(var(--baseHeight)/2.181);
  width: calc(var(--baseWidth)/2.181);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/3.428);
  width: calc(var(--baseWidth)/3.428);
  `}
  
`
}
`
export const Wrapper = styled.div`
${css`
text-align-last: center;
text-align: right;
text-align: -webkit-center;
display: flex;
flex-direction: column;
font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
--BaseFontSize: 18px;
--BaselineHeight: 20px;
font-size:--BaseFontSize ;
line-height:--BaselineHeight ;


${media.between('sm', 'md')`
    font-size: calc(var(--BaseFontSize) / 1.5625);
    line-height: calc(var(--BaselineHeight) / 1.5625);
    `
}
    ${media.between('xs', 'sm')`
    font-size: calc(var(--BaseFontSize) 2.181);
    line-height: calc(var(--BaselineHeight) 2.181);
    `
}
    ${media.lessThan('xs')`
    font-size: calc(var(--BaseFontSize)/3.428);
    line-height: calc(var(--BaselineHeight)/3.428);
    `}
`
}
`
